import axios from 'axios';
import dashboardMock from '../data/dashboardMock';

const DASHBOARD_URL =
  process.env.NODE_ENV === 'development'
    ? '/dashboard.php'
    : 'https://api.boifestmarilia.com.br/dashboard.php';

const USE_MOCK = process.env.REACT_APP_DASHBOARD_MOCK !== 'false';

export const fetchDashboard = async () => {
  if (USE_MOCK) {
    await new Promise((resolve) => setTimeout(resolve, 250));
    return dashboardMock;
  }

  const response = await axios.get(DASHBOARD_URL, { timeout: 10000 });
  return response.data;
};
